import { GeoGovernanceFeaturePage } from "../ui/GeoGovernanceFeaturePage";

/** 历史资源 GEO 批量治理页面入口。 */
export function GeoGovernancePage() {
  return <GeoGovernanceFeaturePage />;
}
